import { IVisitPeriod } from "../types/ownerDashboard.types";

export function getCurrentMonthPeriod(referenceDate = new Date()): IVisitPeriod {
  const month = String(referenceDate.getMonth() + 1).padStart(2, "0");
  const year = referenceDate.getFullYear();
  const lastDay = new Date(year, referenceDate.getMonth() + 1, 0).getDate();

  return {
    initial_date: `${month}/01/${year}`,
    final_date: `${month}/${lastDay}/${year}`,
  };
}
